import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

import { TextType } from '..';

import { SharedConstants } from '@app/eds';

export type radioKeyValueType = {
  title: string;
  value: string;
};

@Component({
  selector: 'app-radio-button[title][radiobuttonChange]',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
  // Form control for the radio button
  dataControl = new FormControl(SharedConstants.EMPTY_STRING);

  // Title provide title for the button i.e. Option1, Option2
  @Input() title: string = SharedConstants.EMPTY_STRING;

  // Value provide value through which the button is differentiated i.e. 1, 2
  @Input() value: string = SharedConstants.EMPTY_STRING;

  // fontWeight, fontColor, fontSize value will be for the data
  @Input() fontType: TextType = 'body';

  // To get the type of the radio button
  @Input() radioType = 'primary';

  // Boolean to specify if the radio should be disabled
  @Input() disabled = false;

  // Boolean to specify if the radio should be selected
  @Input() checked = false;

  // used to group radios for unique selection
  @Input() name!: string;

  // optionSelected is used for emitting event for the changes in the radiobutton
  @Output() radiobuttonChange: EventEmitter<string> = new EventEmitter<string>();

  defaultColor: ThemePalette = 'primary';

  // Translate key for tooltip text.
  @Input() tooltipTextKey!: string;

  // Boolean to specify if the tooltip should be disabled.
  @Input() disableTooltip!: boolean;

  // FormControl field for the radio button
  @Input() set control(value: FormControl) {
    if (value !== this.dataControl) {
      this.dataControl = value;
    }
  }

  /**
   * This method is triggered when a option of radio button is selected.
   *
   * @param {string} Value which option is selected
   */
  onChange = (value: string): void => this.radiobuttonChange.emit(value);
}
